module.exports = __webpack_public_path__ + "static/img/A116.71fe664f.jpg";